// import React, { useRef, useState, useEffect, useContext } from 'react';
// import { Bell, Camera, User } from 'lucide-react';
// import StudentNav from ".././Navbars/StudentNav";
// import './EditProfile.css';
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { UserContext } from '../UserContext';
// import axios from 'axios';
// const EditProfile = () => {
//   const [formData, setFormData] = useState({
//     firstname: '',
//     lastname: '',
//     gender: '',
//     dateofbirth: '',
//     address: '',
//     phonenumber: '',
//     parentname: '',
//     avatar: ''
//   });

//   // Teacher-specific form data
//   const [teacherData, setTeacherData] = useState({
//     degree: '',
//     institution: '',
//     education_duration: '',
//     education_start_date: '',
//     education_end_date: '',
//     education_file: null,
//     designation: '',
//     company: '',
//     experience_duration: '',
//     experience_start_date: '',
//     experience_end_date: '',
//     experience_file: null,
//     availability_day: '',
//     availability_time: '',
//     selected_course: '',
//     meeting_link: '',
//     bank_name: '',
//     iban: '',
//     mobile_wallet: '',
//     payment_preference: ''
//   });

//   const [passwordData, setPasswordData] = useState({
//     oldPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [manualUserId, setManualUserId] = useState('');
//   const [userType, setUserType] = useState('');
//   const [teacherId, setTeacherId] = useState(null);
//   const fileInputRef = useRef(null);
//   const educationFileRef = useRef(null);
//   const experienceFileRef = useRef(null);

//   // Try to get user info from UserContext as fallback
//   const { userInfo, setUserInfo } = useContext(UserContext) || {};

//   // Function to clear ALL cached user data and force fresh login
//   const clearAllUserData = () => {
//     // Clear localStorage
//     localStorage.removeItem("User_id");
//     localStorage.removeItem("username");
//     localStorage.removeItem("usertype");
//     localStorage.removeItem("userInfo");
//     localStorage.removeItem("userRole");

//     // Clear any other possible cached data
//     localStorage.clear();

//     // Clear UserContext if available
//     if (userInfo && typeof setUserInfo === 'function') {
//       setUserInfo({});
//     }

//     toast.success("All cached data cleared. Please login again.");

//     // Redirect to home page for fresh login
//     setTimeout(() => {
//       window.location.href = '/';
//     }, 1000);
//   };

//   // Function to manually set User ID and retry
//   const retryWithManualUserId = () => {
//     if (manualUserId && manualUserId.trim()) {
//       localStorage.setItem("User_id", manualUserId.trim());
//       setError(null);
//       setLoading(true);
//       window.location.reload();
//     } else {
//       toast.error("Please enter a valid User ID");
//     }
//   };

//   // Debug function to show all user data
//   const debugAllUserData = () => {
//     // Try to fetch current session
//     fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
//       credentials: "include",
//     })
//     .then(response => response.json())
//     .then(() => {
//       // Session data processed
//     })
//     .catch(error => {
//       console.error("Session API error:", error);
//     });
//   };

//   // Test image URL function
//   const testImageUrl = () => {
//     const testUrl = formData.avatar || "https://via.placeholder.com/150?text=No+Avatar";
//     const img = new Image();
//     img.onload = () => alert("Image URL is working!");
//     img.onerror = () => alert("Image URL is broken!");
//     img.src = testUrl;
//   };

//   useEffect(() => {
//     const fetchUserData = async () => {
//       try {
//         let userId = null;

//         // Method 1: Try localStorage first (most reliable after login)
//         const storedUserId = localStorage.getItem("User_id");

//         if (storedUserId && storedUserId !== 'null' && storedUserId !== 'undefined') {
//           const parsedUserId = parseInt(storedUserId);

//           if (!isNaN(parsedUserId) && parsedUserId > 0) {
//             userId = parsedUserId.toString();
//           }
//         }

//         // Method 2: Try UserContext if localStorage failed
//         if (!userId) {
//           if (userInfo && userInfo.User_id) {
//             const contextUserId = parseInt(userInfo.User_id);

//             if (!isNaN(contextUserId) && contextUserId > 0) {
//               userId = contextUserId.toString();
//               localStorage.setItem("User_id", userId); // Store for future use
//             }
//           }
//         }

//         // Method 3: Try session API if both failed (PRIORITY METHOD)
//         if (!userId) {
//           try {
//             const sessionResponse = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/`, {
//               method: 'GET',
//               credentials: 'include',
//               headers: {
//                 'Content-Type': 'application/json',
//               }
//             });

//             if (sessionResponse.ok) {
//               const sessionData = await sessionResponse.json();
//               console.log("📋 Session API response:", sessionData);

//               if (sessionData.valid && sessionData.User_id) {
//                 const sessionUserId = parseInt(sessionData.User_id);
//                 if (sessionUserId > 0) {
//                   userId = sessionUserId.toString();
//                   localStorage.setItem("User_id", userId); // Store for future use
//                   console.log("✅ Found valid User_id in session (no range limit):", userId);
//                 } else {
//                   console.log("⚠️ Invalid User_id in session (must be > 0):", sessionUserId);
//                 }
//               } else {
//                 console.log("⚠️ Session invalid or no User_id found");
//               }
//             } else {
//               console.log("⚠️ Session API response not ok:", sessionResponse.status);
//             }
//           } catch (sessionError) {
//             console.log("⚠️ Session API failed:", sessionError.message);
//             if (sessionError.name === 'AbortError') {
//               console.log("⏰ Session API timeout - backend might be overloaded");
//             } else if (sessionError.message.includes('500')) {
//               console.log("💥 Backend crashed during session check - User_id might not exist");
//             }
//           }
//         }

//         if (!userId) {
//           console.log("⚠️ No User_id found - will show manual input option");
//           setShowManualInput(true);
//           return;
//         }

//         const userResponse = await fetch(
//           `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUser/${userId}`,
//           {
//             method: 'GET',
//             credentials: 'include',
//           }
//         );

//         if (!userResponse.ok) {
//           toast.error(`Failed to load user data. Please try again.`);
//           throw new Error(`User data request failed`);
//         }

//         const userData = await userResponse.json();

//         if (!userData || !userData.user) {
//           toast.error(`No user data found. Please try again.`);
//           return;
//         }

//         let finalUserData = userData;

//         if (finalUserData && finalUserData.Data && finalUserData.user) {
//           const detectedUserType = finalUserData.user.usertype ||
//                                  finalUserData.user.userType ||
//                                  finalUserData.user.user_type ||
//                                  finalUserData.user.role ||
//                                  finalUserData.user.Role ||
//                                  userInfo?.usertype ||
//                                  localStorage.getItem("usertype") ||
//                                  'Student';

//           setUserType(detectedUserType);

//           if (detectedUserType === 'Teacher') {
//             console.log('🔍 User is Teacher, fetching Teacher_id...');
//             try {
//               const teacherIdResponse = await fetch(
//                 `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getTeacherId/${userId}`,
//                 { withCredentials: true }
//               );

//               if (teacherIdResponse.ok) {
//                 const teacherIdData = await teacherIdResponse.json();
//                 console.log('📋 Teacher_id response:', teacherIdData);

//                 if (teacherIdData.teacherId) {
//                   setTeacherId(teacherIdData.teacherId);
//                   console.log(`✅ Found Teacher_id: ${teacherIdData.teacherId} for User_id: ${userId}`);

//                   // Fetch bank details for this teacher
//                   console.log('🔍 Fetching bank details...');
//                   try {
//                     const bankResponse = await fetch(
//                       `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getBankDetails/${teacherIdData.teacherId}`,
//                       { withCredentials: true }
//                     );

//                     if (bankResponse.ok) {
//                       const bankData = await bankResponse.json();
//                       console.log('📋 Bank details response:', bankData);

//                       if (bankData.bankDetails) {
//                         setTeacherData(prev => ({
//                           ...prev,
//                           bank_name: bankData.bankDetails.BankName || '',
//                           iban: bankData.bankDetails.BankAccountIBAN || '',
//                           mobile_wallet: bankData.bankDetails.MobileWalletNo || '',
//                           payment_preference: bankData.bankDetails.Preference || ''
//                         }));
//                         console.log('✅ Bank details loaded successfully');
//                       }
//                     } else {
//                       console.log('⚠️ No bank details found or error fetching');
//                     }
//                   } catch (bankError) {
//                     console.log('❌ Error fetching bank details:', bankError.message);
//                   }

//                   // Fetch meeting link for this teacher
//                   console.log('🔍 Fetching meeting link...');
//                   try {
//                     const meetingLinkResponse = await fetch(
//                       `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getMeetLink/${teacherIdData.teacherId}`,
//                       { withCredentials: true }
//                     );

//                     if (meetingLinkResponse.ok) {
//                       const meetingLinkData = await meetingLinkResponse.json();
//                       console.log('📋 Meeting link response:', meetingLinkData);

//                       if (meetingLinkData.meetLink) {
//                         setTeacherData(prev => ({
//                           ...prev,
//                           meeting_link: meetingLinkData.meetLink || ''
//                         }));
//                         console.log('✅ Meeting link loaded successfully:', meetingLinkData.meetLink);
//                       } else {
//                         console.log('⚠️ No meeting link found in response');
//                       }
//                     } else {
//                       console.log('⚠️ No meeting link found or error fetching');
//                     }
//                   } catch (meetingLinkError) {
//                     console.log('❌ Error fetching meeting link:', meetingLinkError.message);
//                   }
//                 } else {
//                   console.log('⚠️ No Teacher_id found in response');
//                 }
//               } else {
//                 console.log('❌ Failed to fetch Teacher_id');
//               }
//             } catch (teacherIdError) {
//               console.log('❌ Error fetching Teacher_id:', teacherIdError.message);
//             }
//           }

//           let avatarUrl = '';
//           if (finalUserData.user.avatar) {
//             let cleanAvatar = finalUserData.user.avatar.trim();

//             if (cleanAvatar.startsWith('//')) {
//               cleanAvatar = cleanAvatar.substring(2);
//             } else if (cleanAvatar.startsWith('/')) {
//               cleanAvatar = cleanAvatar.substring(1);
//             }

//             if (cleanAvatar.includes('s3.amazonaws.com') || cleanAvatar.includes('appforest_uf')) {
//               if (cleanAvatar.startsWith('https://s3.amazonaws.com')) {
//                 avatarUrl = cleanAvatar;
//               } else if (cleanAvatar.startsWith('s3.amazonaws.com')) {
//                 avatarUrl = `https://${cleanAvatar}`;
//               } else if (cleanAvatar.startsWith('//s3.amazonaws.com')) {
//                 avatarUrl = `https:${cleanAvatar}`;
//               } else {
//                 let s3Path = cleanAvatar.replace(/^\/+/, '').replace('s3.amazonaws.com/', '');
//                 avatarUrl = `https://s3.amazonaws.com/${s3Path}`;
//               }
//             } else if (cleanAvatar.startsWith('http')) {
//               avatarUrl = cleanAvatar;
//             } else {
//               avatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${cleanAvatar}`;
//             }
//           }

//           const finalAvatarUrl = avatarUrl || "https://via.placeholder.com/150?text=No+Image";

//           setFormData({
//             firstname: finalUserData.user.firstName || '',
//             lastname: finalUserData.user.lastName || '',
//             gender: finalUserData.user.gender || '',
//             dateofbirth: finalUserData.user.dateofbirth ? new Date(finalUserData.user.dateofbirth).toISOString().substring(0, 10) : '',
//             address: finalUserData.user.address || '',
//             phonenumber: finalUserData.user.phonenumber || '',
//             parentname: finalUserData.user.parentname || '',
//             avatar: finalAvatarUrl
//           });

//           if (finalUserData.user.usertype === 'Teacher') {
//             setTeacherData({
//               degree: finalUserData.user.degree || '',
//               institution: finalUserData.user.institution || '',
//               education_duration: finalUserData.user.education_duration || '',
//               education_start_date: finalUserData.user.education_start_date || '',
//               education_end_date: finalUserData.user.education_end_date || '',
//               education_file: finalUserData.user.education_file || null,
//               designation: finalUserData.user.designation || '',
//               company: finalUserData.user.company || '',
//               experience_duration: finalUserData.user.experience_duration || '',
//               experience_start_date: finalUserData.user.experience_start_date || '',
//               experience_end_date: finalUserData.user.experience_end_date || '',
//               experience_file: finalUserData.user.experience_file || null,
//               availability_day: finalUserData.user.availability_day || '',
//               availability_time: finalUserData.user.availability_time || '',
//               selected_course: finalUserData.user.selected_course || '',
//               meeting_link: finalUserData.user.meeting_link || '',
//               bank_name: finalUserData.user.bank_name || '',
//               iban: finalUserData.user.iban || '',
//               mobile_wallet: finalUserData.user.mobile_wallet || '',
//               payment_preference: finalUserData.user.payment_preference || ''
//             });
//           }
//         } else {
//           console.error("❌ Invalid user data structure:", finalUserData);
//           console.error("❌ Expected: {Data: true, user: {...}}");
//           console.error("❌ Received:", finalUserData);
//           throw new Error("Invalid user data received from server");
//         }
//       } catch (err) {
//         console.error("❌ Error in fetchUserData:", err);
//         console.error("❌ Error details:", err.message);
//         setError(err.message);
//         toast.error(`Failed to load user data: ${err.message}`);
//         console.log("🔧 DEBUG: If you see 'session is not valid', please:");
//         console.log("1. Make sure you are logged in");
//         console.log("2. Check if cookies are enabled");
//         console.log("3. Try logging out and logging in again");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserData();
//   }, []);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handlePasswordChange = (e) => {
//     const { name, value } = e.target;
//     setPasswordData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleTeacherDataChange = (e) => {
//     const { name, value } = e.target;
//     setTeacherData((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleImageClick = () => fileInputRef.current.click();

//   const handleImageError = (e) => {
//     const currentSrc = e.target.src;
//     const avatar = formData.avatar;

//     if (avatar && !currentSrc.includes('placeholder')) {
//       let filename = avatar.split('/').pop();

//       if (filename.includes('%20')) {
//         filename = decodeURIComponent(filename);
//       }

//       const rawAvatar = avatar.replace('//', '');
//       const alternatives = [
//         `https://${rawAvatar}`,
//         `https://s3.amazonaws.com/${rawAvatar.replace('s3.amazonaws.com/', '')}`,
//         "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIiBzdHJva2U9IiNjY2MiLz48dGV4dCB4PSI1MCUiIHk9IjUwJSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjNjY2IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+VXNlcjwvdGV4dD48L3N2Zz4="
//       ];

//       const currentIndex = alternatives.findIndex(alt => alt === currentSrc);
//       const nextIndex = currentIndex + 1;

//       if (nextIndex < alternatives.length) {
//         e.target.src = alternatives[nextIndex];
//       } else {
//         e.target.src = "https://via.placeholder.com/150?text=No+Image";
//       }
//     }
//   };

//   const handleImageLoad = () => {
//     // Image loaded successfully - no console log needed
//   };

//   const handleImageChange = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     try {
//       let userId = userInfo?.User_id || localStorage.getItem("User_id");

//       if (!userId) {
//         toast.error("User not authenticated. Please login again.");
//         return;
//       }

//       const imageForm = new FormData();
//       imageForm.append("avatar", file);

//       const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editUser/${userId}`, {
//         method: "PUT",
//         body: imageForm,
//         credentials: 'include'
//       });

//       const result = await response.json();

//       if (response.ok) {
//         toast.success("Image updated successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });

//         const newAvatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${file.name}`;

//         setFormData(prev => ({
//           ...prev,
//           avatar: newAvatarUrl
//         }));

//         setTimeout(() => {
//           window.location.reload();
//         }, 1000);
//       } else {
//         toast.error(result.message || "Failed to update image");
//       }
//     } catch (error) {
//       console.error("❌ Error uploading image:", error);
//       toast.error("Error uploading image");
//     }
//   };

//   const handleSaveChanges = async () => {
//     try {
//       console.log("💾 Starting profile update...");

//       let userId = userInfo?.User_id || localStorage.getItem("User_id");

//       console.log("💾 Getting User_id for profile update:", userId);
//       console.log("💾 UserContext User_id:", userInfo?.User_id);
//       console.log("💾 localStorage User_id:", localStorage.getItem("User_id"));

//       if (!userId) {
//         toast.error("User not authenticated. Please login again.");
//         return;
//       }

//       console.log("💾 Updating profile for User_id:", userId);
//       console.log("💾 Form data to update:", formData);

//       const form = new FormData();
//       form.append("firstname", formData.firstname);
//       form.append("lastname", formData.lastname);
//       form.append("gender", formData.gender);
//       if (formData.dateofbirth) form.append("dateofbirth", formData.dateofbirth);
//       form.append("address", formData.address);
//       form.append("phonenumber", formData.phonenumber);
//       form.append("parentname", formData.parentname);

//       console.log("💾 NOT sending avatar field to preserve existing image");

//       const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editUser/${userId}`, {
//         method: "PUT",
//         body: form,
//         credentials: 'include'
//       });

//       const result = await response.json();
//       console.log("💾 Profile update response:", result);

//       if (response.ok) {
//         toast.success("Profile updated successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });
//       } else {
//         toast.error(result.message || "Update failed");
//       }
//     } catch (err) {
//       console.error("❌ Error updating profile:", err);
//       toast.error("An error occurred while updating profile");
//     }
//   };

//   const handleChangePassword = async () => {
//     const { oldPassword, newPassword, confirmPassword } = passwordData;

//     if (!oldPassword || !newPassword || !confirmPassword) return toast.error("All fields required");
//     if (newPassword !== confirmPassword) return toast.error("Passwords do not match");

//     try {
//       console.log("🔐 Starting password change...");

//       let userId = userInfo?.User_id || localStorage.getItem("User_id");

//       console.log("🔐 Getting User_id for password change:", userId);
//       console.log("🔐 UserContext User_id:", userInfo?.User_id);
//       console.log("🔐 localStorage User_id:", localStorage.getItem("User_id"));

//       if (!userId) {
//         toast.error("User not authenticated. Please login again.");
//         return;
//       }
//       console.log("🔐 Changing password for User_id:", userId);

//       const checkRes = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/checkOldPassword`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ oldPassword, User_id: userId }),
//         credentials: 'include'
//       });

//       console.log("🔐 Password check response status:", checkRes.status);

//       if (checkRes.status !== 200) {
//         return toast.error("Old password incorrect");
//       }

//       const updateRes = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updatePassword`, {
//         method: "PUT",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ userId, newPassword }),
//         credentials: 'include'
//       });

//       const result = await updateRes.json();
//       console.log("🔐 Password update response:", result);

//       if (updateRes.ok) {
//         toast.success("Password updated successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });
//         setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
//       } else {
//         toast.error(result.message || "Password update failed");
//       }
//     } catch (error) {
//       console.error("❌ Error updating password:", error);
//       toast.error("An error occurred while updating password");
//     }
//   };

//   // Updated Education Save Function (from Teacher.js)
//   const handleSaveEducation = async () => {
//     if (!teacherId) {
//       toast.error('Teacher ID not found. Please try refreshing the page.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append("degreeName", teacherData.degree);
//     formData.append("instituteName", teacherData.institution);
//     formData.append("DurationOfCourse", teacherData.education_duration);
//     formData.append("yearStart", teacherData.education_start_date ? parseInt(teacherData.education_start_date.split('-')[0]) : '');
//     formData.append("yearEnd", teacherData.education_end_date ? parseInt(teacherData.education_end_date.split('-')[0]) : '');
//     formData.append("degreeFile", teacherData.education_file);

//     if (!teacherData.degree || !teacherData.institution || !teacherData.education_duration || !teacherData.education_start_date || !teacherData.education_end_date) {
//       toast.error('All fields are required.', {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 2000,
//       });
//     } else {
//       axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveEducationDetails/${teacherId}`, formData)
//         .then(response => {
//           toast.success('Education data has been saved.', {
//             position: toast.POSITION.TOP_CENTER,
//             autoClose: 2000,
//           });
//           // Note: Add fetchEducationData function if needed to refresh data
//           // fetchEducationData(teacherId);
//         })
//         .catch(error => {
//           toast.error('Something went wrong.', {
//             position: toast.POSITION.TOP_CENTER,
//             autoClose: 2000,
//           });
//           console.log('Error saving education details', error);
//         });
//     }
//   };

//   // Updated Experience Save Function (from Teacher.js)
//   const handleSaveExperience = async () => {
//     if (!teacherId) {
//       toast.error('Teacher ID not found. Please try refreshing the page.');
//       return;
//     }

//     const formData = new FormData();
//     formData.append("designation", teacherData.designation);
//     formData.append("company", teacherData.company);
//     formData.append("DurationOfService", teacherData.experience_duration);
//     formData.append("yearStart", teacherData.experience_start_date ? parseInt(teacherData.experience_start_date.split('-')[0]) : '');
//     formData.append("yearEnd", teacherData.experience_end_date ? parseInt(teacherData.experience_end_date.split('-')[0]) : '');
//     formData.append("expFile", teacherData.experience_file);

//     if (!teacherData.designation || !teacherData.company || !teacherData.experience_duration || !teacherData.experience_start_date || !teacherData.experience_end_date) {
//       toast.error('All fields are required.', {
//         position: toast.POSITION.TOP_CENTER,
//         autoClose: 2000,
//       });
//     } else {
//       axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveExperienceDetails/${teacherId}`, formData)
//         .then(response => {
//           toast.success('Experience data has been saved.', {
//             position: toast.POSITION.TOP_CENTER,
//             autoClose: 2000,
//           });
//           // Note: Add fetchExperienceData function if needed to refresh data
//           // fetchExperienceData(teacherId);
//         })
//         .catch(error => {
//           toast.error('Something went wrong.', {
//             position: toast.POSITION.TOP_CENTER,
//             autoClose: 2000,
//           });
//           console.log('Error saving experience details', error);
//         });
//     }
//   };

//   const handleSaveAvailability = async () => {
//     if (!teacherId) {
//       toast.error("Teacher ID not found. Please try refreshing the page.");
//       return;
//     }

//     const selectedDay = teacherData.availability_day;
//     const selectedTime = teacherData.availability_time;

//     if (!selectedDay || !selectedTime) {
//       toast.error("Please select both day and time for availability.");
//       return;
//     }

//     const availabilityData = {
//       [selectedDay]: {
//         day: selectedDay,
//         time: selectedTime
//       }
//     };

//     console.log('💾 Saving availability:', availabilityData);
//     console.log('💾 Teacher_id:', teacherId);

//     try {
//       const response = await fetch(
//         `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editTeacherAvailability/${teacherId}`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           credentials: 'include',
//           body: JSON.stringify(availabilityData),
//         }
//       );

//       if (response.ok) {
//         toast.success("Availability saved successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });

//         setTeacherData(prev => ({
//           ...prev,
//           availability_day: '',
//           availability_time: ''
//         }));

//         console.log('✅ Availability saved successfully');
//       } else {
//         const errorData = await response.json();
//         console.log('❌ Failed to save availability:', errorData);
//         toast.error("Failed to save availability. Please try again.");
//       }
//     } catch (error) {
//       console.error('❌ Error saving availability:', error);
//       toast.error("Error saving availability. Please check your connection.");
//     }
//   };

//   const handleSaveCourse = () => {
//     toast.success("Course saved successfully", {
//       position: "top-center",
//       autoClose: 2000,
//     });
//   };

//   const handleSaveMeetingLink = async () => {
//     if (!teacherId) {
//       toast.error("Teacher ID not found. Please try refreshing the page.");
//       return;
//     }

//     const meetingLink = teacherData.meeting_link;

//     if (!meetingLink || !meetingLink.trim()) {
//       toast.error("Please enter a meeting link.");
//       return;
//     }

//     const currentUserId = localStorage.getItem("User_id");
//     if (!currentUserId) {
//       toast.error("User ID not found. Please refresh the page and try again.");
//       return;
//     }

//     console.log('💾 Saving meeting link:', meetingLink);
//     console.log('💾 Teacher_id:', teacherId);
//     console.log('💾 User_id:', currentUserId);

//     try {
//       const response = await fetch(
//         `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveMeetLink/${teacherId}`,
//         {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           credentials: 'include',
//           body: JSON.stringify({
//             meetLink: meetingLink.trim()
//           }),
//         }
//       );

//       console.log('📋 Meeting link response status:', response.status);
//       console.log('📋 Meeting link response ok:', response.ok);

//       if (response.ok) {
//         const successData = await response.json();
//         console.log('✅ Meeting link saved successfully:', successData);
//         toast.success("Meeting link saved successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });
//       } else {
//         console.log('❌ Meeting link response not ok, status:', response.status);
//         try {
//           const errorData = await response.json();
//           console.log('❌ Meeting link error response:', errorData);
//           toast.error(`Failed to save meeting link: ${errorData.message || 'Unknown error'}`);
//         } catch (parseError) {
//           console.log('❌ Could not parse meeting link error response:', parseError);
//           const errorText = await response.text();
//           console.log('❌ Raw meeting link error response:', errorText);
//           toast.error("Failed to save meeting link. Please try again.");
//         }
//       }
//     } catch (error) {
//       console.error('❌ Error saving meeting link:', error);
//       toast.error("Error saving meeting link. Please check your connection.");
//     }
//   };

//   const handleSaveBankDetails = async () => {
//     if (!teacherId) {
//       toast.error("Teacher ID not found. Please try refreshing the page.");
//       return;
//     }

//     const bankData = {
//       BankName: teacherData.bank_name,
//       BankAccountIBAN: teacherData.iban,
//       MobileWalletNo: teacherData.mobile_wallet,
//       Preference: teacherData.payment_preference,
//       MobileWallletName: 'Mobile Wallet'
//     };

//     if (!bankData.Preference) {
//       toast.error("Please select a payment preference.");
//       return;
//     }

//     if (bankData.Preference === 'Bank Transfer' && (!bankData.BankName || !bankData.BankAccountIBAN)) {
//       toast.error("Please fill in bank name and IBAN for bank transfer.");
//       return;
//     }

//     if (bankData.Preference === 'Mobile Wallet' && !bankData.MobileWalletNo) {
//       toast.error("Please fill in mobile wallet number.");
//       return;
//     }

//     console.log('💾 Saving bank details:', bankData);
//     console.log('💾 Teacher_id:', teacherId);
//     console.log('💾 API URL:', `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editBankDetails/${teacherId}`);
//     console.log('💾 Request body:', JSON.stringify(bankData));

//     try {
//       const response = await fetch(
//         `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editBankDetails/${teacherId}`,
//         {
//           method: 'PUT',
//           headers: {
//             'Content-Type': 'application/json',
//           },
//           credentials: 'include',
//           body: JSON.stringify(bankData),
//         }
//       );

//       console.log('📋 Response status:', response.status);
//       console.log('📋 Response ok:', response.ok);

//       if (response.ok) {
//         const successData = await response.json();
//         console.log('✅ Bank details saved successfully:', successData);
//         toast.success("Bank details saved successfully", {
//           position: "top-center",
//           autoClose: 2000,
//         });
//       } else {
//         console.log('❌ Response not ok, status:', response.status);
//         try {
//           const errorData = await response.json();
//           console.log('❌ Error response data:', errorData);
//           toast.error(`Failed to save bank details: ${errorData.message || 'Unknown error'}`);
//         } catch (parseError) {
//           console.log('❌ Could not parse error response:', parseError);
//           const errorText = await response.text();
//           console.log('❌ Raw error response:', errorText);
//           toast.error("Failed to save bank details. Please try again.");
//         }
//       }
//     } catch (error) {
//       console.error('❌ Error saving bank details:', error);
//       toast.error("Error saving bank details. Please check your connection.");
//     }
//   };

//   if (loading) {
//     return (
//       <div className="loading-container">
//         <div>Loading user data...</div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="error-container">
//         <h2>❌ Authentication Error</h2>
//         <p><strong>Issue:</strong> {error}</p>

//         <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '5px' }}>
//           <h3>🔍 Quick Diagnosis:</h3>
//           <p><strong>This error means you are not properly logged in.</strong></p>

//           <h4>Please check:</h4>
//           <ol>
//             <li><strong>Are you logged in?</strong> - Look at the top navigation bar. Do you see your name/avatar?</li>
//             <li><strong>Did login succeed?</strong> - After entering username/password, were you redirected to dashboard?</li>
//             <li><strong>Session expired?</strong> - Try logging out and logging in again</li>
//           </ol>
//         </div>

//         <div style={{ marginTop: '20px' }}>
//           <h3>🔧 Solutions:</h3>
//           <ul>
//             <li><strong>Step 1:</strong> Go to home page and login again</li>
//             <li><strong>Step 2:</strong> Make sure you see your name in the navigation bar after login</li>
//             <li><strong>Step 3:</strong> Then try accessing Edit Profile again</li>
//           </ul>
//         </div>

//         <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '5px' }}>
//           <h4>🔧 User ID Required:</h4>
//           <p><strong>The session system is not working properly.</strong></p>
//           <p>Please enter your User ID to access your profile:</p>
//           <div style={{ marginBottom: '10px' }}>
//             <input
//               type="text"
//               placeholder="Enter your User ID (e.g., 1, 2, 3, etc.)"
//               value={manualUserId}
//               onChange={(e) => setManualUserId(e.target.value)}
//               style={{ padding: '8px', marginRight: '10px', border: '1px solid #ccc', borderRadius: '3px', width: '200px' }}
//             />
//             <button onClick={retryWithManualUserId} style={{ padding: '8px 15px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '3px' }}>
//               Load My Profile
//             </button>
//           </div>
//           <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '3px' }}>
//             <strong>💡 How to find your User ID:</strong>
//             <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
//               <li>Check with your administrator</li>
//               <li>Look at your registration confirmation</li>
//               <li>Try common IDs: 1, 2, 3, etc.</li>
//             </ul>
//           </div>
//         </div>

//         <div style={{ marginTop: '20px' }}>
//           <button onClick={() => window.location.href = '/'} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
//             🏠 Go to Home & Login
//           </button>
//           <button onClick={clearAllUserData} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px' }}>
//             🧹 Clear All Data & Fresh Login
//           </button>
//           <button onClick={debugAllUserData} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#6f42c1', color: 'white', border: 'none', borderRadius: '5px' }}>
//             🔍 Debug User Data
//           </button>
//           <button onClick={testImageUrl} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '5px' }}>
//             🧪 Test Image URL
//           </button>
//           <button onClick={() => window.location.reload()} style={{ marginTop: '10px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px' }}>
//             🔄 Refresh Page
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (userType === 'Teacher') {
//     return (
//       <div className="profile-layout">
//         <div className="profile-container">
//           <div className="header-section">
//             <h1 className="profile-title">Profile</h1>
//             <div className="user-notification">
//               <Bell className="notification-icon" size={20} />
//               <span className="user-name">{formData.firstname} {formData.lastname}</span>
//               <div className="user-avatar">
//                 <User size={16} />
//               </div>
//             </div>
//           </div>

//           {/* Personal Info Section */}
//           <div className="personal-info-section">
//             <h2 className="section-title">Personal Info</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">First Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="firstname"
//                     value={formData.firstname}
//                     onChange={handleInputChange}
//                     placeholder="Enter first name"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Last Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="lastname"
//                     value={formData.lastname}
//                     onChange={handleInputChange}
//                     placeholder="Enter last name"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Gender</label>
//                   <select
//                     className="form-input"
//                     name="gender"
//                     value={formData.gender}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Gender</option>
//                     <option value="male">Male</option>
//                     <option value="female">Female</option>
//                     <option value="other">Other</option>
//                   </select>
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Birthday</label>
//                   <input
//                     type="date"
//                     className="form-input"
//                     name="dateofbirth"
//                     value={formData.dateofbirth}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Address</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="address"
//                     value={formData.address}
//                     onChange={handleInputChange}
//                     placeholder="Enter address"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Phone No</label>
//                   <input
//                     type="tel"
//                     className="form-input"
//                     name="phonenumber"
//                     value={formData.phonenumber}
//                     onChange={handleInputChange}
//                     placeholder="Enter phone number"
//                   />
//                 </div>
//               </div>
//               <div className="button-container">
//                 <button type="button" className="save-button" onClick={handleSaveChanges}>Save Changes</button>
//               </div>
//             </form>
//           </div>

//           {/* Education Section */}
//           <div className="section">
//             <h2 className="section-title">Education</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Degree Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="degree"
//                     value={teacherData.degree}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter degree"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Institution Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="institution"
//                     value={teacherData.institution}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter institution"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Duration</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="education_duration"
//                     value={teacherData.education_duration}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter duration"
//                   />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Start Date</label>
//                   <input
//                     type="date"
//                     className="form-input"
//                     name="education_start_date"
//                     value={teacherData.education_start_date}
//                     onChange={handleTeacherDataChange}
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">End Date</label>
//                   <input
//                     type="date"
//                     className="form-input"
//                     name="education_end_date"
//                     value={teacherData.education_end_date}
//                     onChange={handleTeacherDataChange}
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Upload File</label>
//                   <input
//                     type="file"
//                     className="form-input"
//                     ref={educationFileRef}
//                     onChange={(e) => setTeacherData(prev => ({...prev, education_file: e.target.files[0]}))}
//                     accept=".pdf,.doc,.docx"
//                   />
//                 </div>
//               </div>
//               <div className="button-container">
//                 <button type="button" className="save-button" onClick={handleSaveEducation}>Save Changes</button>
//               </div>
//             </form>
//           </div>

//           {/* Experience Section */}
//           <div className="section">
//             <h2 className="section-title">Experience</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Designation</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="designation"
//                     value={teacherData.designation}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter designation"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Company Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="company"
//                     value={teacherData.company}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter company"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Duration Of Service</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="experience_duration"
//                     value={teacherData.experience_duration}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter duration"
//                   />
//                 </div>
//               </div>
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Start Date</label>
//                   <input
//                     type="date"
//                     className="form-input"
//                     name="experience_start_date"
//                     value={teacherData.experience_start_date}
//                     onChange={handleTeacherDataChange}
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">End Date</label>
//                   <input
//                     type="date"
//                     className="form-input"
//                     name="experience_end_date"
//                     value={teacherData.experience_end_date}
//                     onChange={handleTeacherDataChange}
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Upload File</label>
//                   <input
//                     type="file"
//                     className="form-input"
//                     ref={experienceFileRef}
//                     onChange={(e) => setTeacherData(prev => ({...prev, experience_file: e.target.files[0]}))}
//                     accept=".pdf,.doc,.docx"
//                   />
//                 </div>
//               </div>
//               <div className="button-container">
//                 <button type="button" className="save-button" onClick={handleSaveExperience}>Save Changes</button>
//               </div>
//             </form>
//           </div>

//           {/* Weekly Availability Section */}
//           <div className="section">
//             <h2 className="section-title">Weekly Availability</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Select Day</label>
//                   <select
//                     className="form-input"
//                     name="availability_day"
//                     value={teacherData.availability_day}
//                     onChange={handleTeacherDataChange}
//                   >
//                     <option value="">Select Day</option>
//                     <option value="Monday">Monday</option>
//                     <option value="Tuesday">Tuesday</option>
//                     <option value="Wednesday">Wednesday</option>
//                     <option value="Thursday">Thursday</option>
//                     <option value="Friday">Friday</option>
//                     <option value="Saturday">Saturday</option>
//                     <option value="Sunday">Sunday</option>
//                   </select>
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Select Time</label>
//                   <select
//                     className="form-input"
//                     name="availability_time"
//                     value={teacherData.availability_time}
//                     onChange={handleTeacherDataChange}
//                   >
//                     <option value="">Select Time</option>
//                     <option value="9:00 AM - 5:00 PM">9:00 AM - 5:00 PM</option>
//                     <option value="10:00 AM - 6:00 PM">10:00 AM - 6:00 PM</option>
//                     <option value="11:00 AM - 7:00 PM">11:00 AM - 7:00 PM</option>
//                   </select>
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label"> </label>
//                   <button type="button" className="form-input save-button" onClick={handleSaveAvailability}>Add Availability</button>
//                 </div>
//               </div>
//             </form>
//           </div>

//           {/* Courses Section */}
//           <div className="section">
//             <h2 className="section-title">Courses</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Select Course</label>
//                   <select
//                     className="form-input"
//                     name="selected_course"
//                     value={teacherData.selected_course}
//                     onChange={handleTeacherDataChange}
//                   >
//                     <option value="">Select a course</option>
//                     <option value="Web Development">Web Development</option>
//                     <option value="Mobile Development">Mobile Development</option>
//                     <option value="Data Science">Data Science</option>
//                   </select>
//                 </div>
//                 <div className="input-group"></div>
//                 <div className="input-group">
//                   <label className="input-label"> </label>
//                   <button type="button" className="form-input save-button" onClick={handleSaveCourse}>Save Changes</button>
//                 </div>
//               </div>
//             </form>
//           </div>

//           {/* Meeting Link Section */}
//           <div className="section">
//             <h2 className="section-title">Meeting Link</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Meeting Link</label>
//                   <input
//                     type="url"
//                     className="form-input"
//                     name="meeting_link"
//                     value={teacherData.meeting_link}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter meeting link"
//                   />
//                 </div>
//                 <div className="input-group"></div>
//                 <div className="input-group">
//                   <label className="input-label"> </label>
//                   <button type="button" className="form-input save-button" onClick={handleSaveMeetingLink}>Save Changes</button>
//                 </div>
//               </div>
//             </form>
//           </div>

//           {/* Bank Details Section */}
//           <div className="section">
//             <h2 className="section-title">Bank Details</h2>
//             <form className="info-form">
//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Bank Name</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="bank_name"
//                     value={teacherData.bank_name}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter bank name"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">IBAN</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="iban"
//                     value={teacherData.iban}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter IBAN"
//                   />
//                 </div>
//                 <div className="input-group">
//                   <label className="input-label">Mobile Wallet</label>
//                   <input
//                     type="text"
//                     className="form-input"
//                     name="mobile_wallet"
//                     value={teacherData.mobile_wallet}
//                     onChange={handleTeacherDataChange}
//                     placeholder="Enter mobile number"
//                   />
//                 </div>
//               </div>

//               <div className="form-row">
//                 <div className="input-group">
//                   <label className="input-label">Payment Preference</label>
//                   <select
//                     className="form-input"
//                     name="payment_preference"
//                     value={teacherData.payment_preference}
//                     onChange={handleTeacherDataChange}
//                   >
//                     <option value="">Select Payment Method</option>
//                     <option value="Bank Transfer">Bank Transfer</option>
//                     <option value="Mobile Wallet">Mobile Wallet</option>
//                   </select>
//                 </div>
//                 <div className="input-group"></div>
//                 <div className="input-group"></div>
//               </div>

//               <div className="button-container">
//                 <button type="button" className="save-button" onClick={handleSaveBankDetails}>Save Changes</button>
//               </div>
//             </form>
//           </div>

//           <ToastContainer />
//         </div>
//       </div>
//     );
//   }

//   return (
//     <>
//       <StudentNav />
//       <div className="profile-container">
//         <div className="profile-header">
//           <h1>Profile</h1>
//           <div className="profile-header-right">
//             <div className="notification-container">
//               <Bell className="notification-icon" size={28} />
//               <div className="notification-badge"></div>
//             </div>
//             <div className="user-info">
//               <div className="user-avatar">
//                 <img
//                   src={formData.avatar || "https://via.placeholder.com/150?text=No+Avatar"}
//                   alt="User Avatar"
//                   onError={handleImageError}
//                   onLoad={handleImageLoad}
//                 />
//               </div>
//               <span className="user-name">{formData.firstname || 'User'} {formData.lastname}</span>
//             </div>
//           </div>
//         </div>

//         <div className="profile-content">
//           <div className="profile-image-section">
//             <div className="profile-image-container">
//               <div className="profile-image">
//                 <img
//                   src={formData.avatar || "https://via.placeholder.com/150?text=No+Image"}
//                   alt="Profile"
//                   onError={handleImageError}
//                   onLoad={handleImageLoad}
//                 />
//               </div>
//               <div className="edit-profile-overlay" onClick={handleImageClick}>
//                 <Camera size={16} />
//                 <span>Edit Profile Image</span>
//                 <input
//                   type="file"
//                   accept="image/*"
//                   ref={fileInputRef}
//                   onChange={handleImageChange}
//                   style={{ display: "none" }}
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="profile-form">
//             <div className="form-row">
//               <div className="form-group">
//                 <label>First Name:</label>
//                 <input type="text" name="firstname" value={formData.firstname} onChange={handleInputChange} />
//               </div>
//               <div className="form-group">
//                 <label>Last Name:</label>
//                 <input type="text" name="lastname" value={formData.lastname} onChange={handleInputChange} />
//               </div>
//               <div className="form-group">
//                 <label>Gender:</label>
//                 <input type="text" name="gender" value={formData.gender} onChange={handleInputChange} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="form-group">
//                 <label>Birthday:</label>
//                 <input type="date" name="dateofbirth" value={formData.dateofbirth} onChange={handleInputChange} />
//               </div>
//               <div className="form-group">
//                 <label>Address:</label>
//                 <input type="text" name="address" value={formData.address} onChange={handleInputChange} />
//               </div>
//               <div className="form-group">
//                 <label>Phone No:</label>
//                 <input type="text" name="phonenumber" value={formData.phonenumber} onChange={handleInputChange} />
//               </div>
//             </div>
//             <div className="form-row">
//               <div className="form-group parent-name">
//                 <label>Parent Name:</label>
//                 <input type="text" name="parentname" value={formData.parentname} onChange={handleInputChange} />
//               </div>
//             </div>
//             <div className="save-changes-section">
//               <button className="save-changes-btn" onClick={handleSaveChanges}>Save Changes</button>
//             </div>
//           </div>

//           <div className="change-password-section">
//             <h2>Change Password</h2>
//             <div className="password-form">
//               <div className="password-row">
//                 <div className="form-group">
//                   <label>Old Password:</label>
//                   <input type="password" name="oldPassword" value={passwordData.oldPassword} onChange={handlePasswordChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>New Password:</label>
//                   <input type="password" name="newPassword" value={passwordData.newPassword} onChange={handlePasswordChange} />
//                 </div>
//                 <div className="form-group">
//                   <label>Confirm Password:</label>
//                   <input type="password" name="confirmPassword" value={passwordData.confirmPassword} onChange={handlePasswordChange} />
//                 </div>
//               </div>
//               <div className="password-actions">
//                 <button className="change-password-btn" onClick={handleChangePassword}>Change Password</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </>
//   );
// };

// export default EditProfile;




import React, { useRef, useState, useEffect, useContext } from 'react';
import { Bell, Camera, User } from 'lucide-react';
import StudentNav from ".././Navbars/StudentNav";
import AdminNav from ".././Navbars/AdminNav";
import TeacherNav from ".././Navbars/TeacherNav";
import './EditProfile.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { UserContext } from '../UserContext';
import axios from 'axios';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
const EditProfile = () => {
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    gender: '',
    dateofbirth: '',
    address: '',
    phonenumber: '',
    parentname: '',
    avatar: ''
  });

  // Teacher-specific form data
  const [teacherData, setTeacherData] = useState({
    degree: '',
    institution: '',
    education_duration: '',
    education_start_date: '',
    education_end_date: '',
    education_file: null,
    designation: '',
    company: '',
    experience_duration: '',
    experience_start_date: '',
    experience_end_date: '',
    experience_file: null,
    availability_day: '',
    availability_time: '',
    selected_course: '',
    meeting_link: '',
    bank_name: '',
    iban: '',
    mobile_wallet: '',
    payment_preference: ''
  });

  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [manualUserId, setManualUserId] = useState('');
  const [userType, setUserType] = useState('');
  const [teacherId, setTeacherId] = useState(null);
  const fileInputRef = useRef(null);
  const educationFileRef = useRef(null);
  const experienceFileRef = useRef(null);

  // Try to get user info from UserContext as fallback
  const { userInfo, setUserInfo, isAdmin, isStudent, isTeacher } = useContext(UserContext) || {};

  // Password visibility toggle functions
  const toggleOldPasswordVisibility = () => {
    setShowOldPassword(!showOldPassword);
  };

  const toggleNewPasswordVisibility = () => {
    setShowNewPassword(!showNewPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  // Logout function
  const onLogout = async () => {
    try {
      await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
        credentials: "include",
        method: "POST",
      });
      setUserInfo(null);
      localStorage.clear();
      window.location.href = '/';
    } catch (error) {
      console.error('Logout error:', error);
      // Force logout even if API fails
      setUserInfo(null);
      localStorage.clear();
      window.location.href = '/';
    }
  };

  // Function to clear ALL cached user data and force fresh login
  const clearAllUserData = () => {
    // Clear localStorage
    localStorage.removeItem("User_id");
    localStorage.removeItem("username");
    localStorage.removeItem("usertype");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userRole");

    // Clear any other possible cached data
    localStorage.clear();

    // Clear UserContext if available
    if (userInfo && typeof setUserInfo === 'function') {
      setUserInfo({});
    }

    toast.success("All cached data cleared. Please login again.");

    // Redirect to home page for fresh login
    setTimeout(() => {
      window.location.href = '/';
    }, 1000);
  };

  // Function to manually set User ID and retry
  const retryWithManualUserId = () => {
    if (manualUserId && manualUserId.trim()) {
      localStorage.setItem("User_id", manualUserId.trim());
      setError(null);
      setLoading(true);
      window.location.reload();
    } else {
      toast.error("Please enter a valid User ID");
    }
  };

  // Debug function to show all user data
  const debugAllUserData = () => {
    // Try to fetch current session
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
      credentials: "include",
    })
      .then(response => response.json())
      .then(() => {
        // Session data processed
      })
      .catch(error => {
        console.error("Session API error:", error);
      });
  };

  // Test image URL function
  const testImageUrl = () => {
    const testUrl = formData.avatar || "https://via.placeholder.com/150?text=No+Avatar";
    const img = new Image();
    img.onload = () => alert("Image URL is working!");
    img.onerror = () => alert("Image URL is broken!");
    img.src = testUrl;
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        let userId = null;

        // Method 1: Try localStorage first (most reliable after login)
        const storedUserId = localStorage.getItem("User_id");

        if (storedUserId && storedUserId !== 'null' && storedUserId !== 'undefined') {
          const parsedUserId = parseInt(storedUserId);

          if (!isNaN(parsedUserId) && parsedUserId > 0) {
            userId = parsedUserId.toString();
          }
        }

        // Method 2: Try UserContext if localStorage failed
        if (!userId) {
          if (userInfo && userInfo.User_id) {
            const contextUserId = parseInt(userInfo.User_id);

            if (!isNaN(contextUserId) && contextUserId > 0) {
              userId = contextUserId.toString();
              localStorage.setItem("User_id", userId); // Store for future use
            }
          }
        }

        // Method 3: Try session API if both failed (PRIORITY METHOD)
        if (!userId) {
          try {
            const sessionResponse = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/`, {
              method: 'GET',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
              }
            });

            if (sessionResponse.ok) {
              const sessionData = await sessionResponse.json();
              console.log("📋 Session API response:", sessionData);

              if (sessionData.valid && sessionData.User_id) {
                const sessionUserId = parseInt(sessionData.User_id);
                if (sessionUserId > 0) {
                  userId = sessionUserId.toString();
                  localStorage.setItem("User_id", userId); // Store for future use
                  console.log("✅ Found valid User_id in session (no range limit):", userId);
                } else {
                  console.log("⚠️ Invalid User_id in session (must be > 0):", sessionUserId);
                }
              } else {
                console.log("⚠️ Session invalid or no User_id found");
              }
            } else {
              console.log("⚠️ Session API response not ok:", sessionResponse.status);
            }
          } catch (sessionError) {
            console.log("⚠️ Session API failed:", sessionError.message);
            if (sessionError.name === 'AbortError') {
              console.log("⏰ Session API timeout - backend might be overloaded");
            } else if (sessionError.message.includes('500')) {
              console.log("💥 Backend crashed during session check - User_id might not exist");
            }
          }
        }

        if (!userId) {
          console.log("⚠️ No User_id found - will show manual input option");
          setShowManualInput(true);
          return;
        }

        const userResponse = await fetch(
          `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUser/${userId}`,
          {
            method: 'GET',
            credentials: 'include',
          }
        );

        if (!userResponse.ok) {
          toast.error(`Failed to load user data. Please try again.`);
          throw new Error(`User data request failed`);
        }

        const userData = await userResponse.json();

        if (!userData || !userData.user) {
          toast.error(`No user data found. Please try again.`);
          return;
        }

        let finalUserData = userData;

        if (finalUserData && finalUserData.Data && finalUserData.user) {
          const detectedUserType = finalUserData.user.usertype ||
            finalUserData.user.userType ||
            finalUserData.user.user_type ||
            finalUserData.user.role ||
            finalUserData.user.Role ||
            userInfo?.usertype ||
            localStorage.getItem("usertype") ||
            'Student';

          setUserType(detectedUserType);

          if (detectedUserType === 'Teacher') {
            console.log('🔍 User is Teacher, fetching Teacher_id...');
            try {
              const teacherIdResponse = await fetch(
                `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getTeacherId/${userId}`,
                { withCredentials: true }
              );

              if (teacherIdResponse.ok) {
                const teacherIdData = await teacherIdResponse.json();
                console.log('📋 Teacher_id response:', teacherIdData);

                if (teacherIdData.teacherId) {
                  setTeacherId(teacherIdData.teacherId);
                  console.log(`✅ Found Teacher_id: ${teacherIdData.teacherId} for User_id: ${userId}`);

                  // Fetch bank details for this teacher
                  console.log('🔍 Fetching bank details...');
                  try {
                    const bankResponse = await fetch(
                      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getBankDetails/${teacherIdData.teacherId}`,
                      { withCredentials: true }
                    );

                    if (bankResponse.ok) {
                      const bankData = await bankResponse.json();
                      console.log('📋 Bank details response:', bankData);

                      if (bankData.bankDetails) {
                        setTeacherData(prev => ({
                          ...prev,
                          bank_name: bankData.bankDetails.BankName || '',
                          iban: bankData.bankDetails.BankAccountIBAN || '',
                          mobile_wallet: bankData.bankDetails.MobileWalletNo || '',
                          payment_preference: bankData.bankDetails.Preference || ''
                        }));
                        console.log('✅ Bank details loaded successfully');
                      }
                    } else {
                      console.log('⚠️ No bank details found or error fetching');
                    }
                  } catch (bankError) {
                    console.log('❌ Error fetching bank details:', bankError.message);
                  }

                  // Fetch meeting link for this teacher
                  console.log('🔍 Fetching meeting link...');
                  try {
                    const meetingLinkResponse = await fetch(
                      `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getMeetLink/${teacherIdData.teacherId}`,
                      { withCredentials: true }
                    );

                    if (meetingLinkResponse.ok) {
                      const meetingLinkData = await meetingLinkResponse.json();
                      if (meetingLinkData.meetLink) {
                        setTeacherData(prev => ({
                          ...prev,
                          meeting_link: meetingLinkData.meetLink || ''
                        }));
                      }
                    }
                  } catch (meetingLinkError) {
                    console.log('❌ Error fetching meeting link:', meetingLinkError.message);
                  }

                  // ✅ NEW: Fetch Education and Experience
                  fetchEducationData(teacherIdData.teacherId);
                  fetchExperienceData(teacherIdData.teacherId);
                }
              } else {
                console.log('❌ Failed to fetch Teacher_id');
              }
            } catch (teacherIdError) {
              console.log('❌ Error fetching Teacher_id:', teacherIdError.message);
            }
          }

          let avatarUrl = '';
          if (finalUserData.user.avatar) {
            let cleanAvatar = finalUserData.user.avatar.trim();

            if (cleanAvatar.startsWith('//')) {
              cleanAvatar = cleanAvatar.substring(2);
            } else if (cleanAvatar.startsWith('/')) {
              cleanAvatar = cleanAvatar.substring(1);
            }

            if (cleanAvatar.includes('s3.amazonaws.com') || cleanAvatar.includes('appforest_uf')) {
              if (cleanAvatar.startsWith('https://s3.amazonaws.com')) {
                avatarUrl = cleanAvatar;
              } else if (cleanAvatar.startsWith('s3.amazonaws.com')) {
                avatarUrl = `https://${cleanAvatar}`;
              } else if (cleanAvatar.startsWith('//s3.amazonaws.com')) {
                avatarUrl = `https:${cleanAvatar}`;
              } else {
                let s3Path = cleanAvatar.replace(/^\/+/, '').replace('s3.amazonaws.com/', '');
                avatarUrl = `https://s3.amazonaws.com/${s3Path}`;
              }
            } else if (cleanAvatar.startsWith('http')) {
              avatarUrl = cleanAvatar;
            } else {
              avatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${cleanAvatar}`;
            }
          }

          const finalAvatarUrl = avatarUrl || "https://via.placeholder.com/150?text=No+Image";

          setFormData({
            firstname: finalUserData.user.firstName || '',
            lastname: finalUserData.user.lastName || '',
            gender: finalUserData.user.gender || '',
            dateofbirth: finalUserData.user.dateofbirth ? new Date(finalUserData.user.dateofbirth).toISOString().substring(0, 10) : '',
            address: finalUserData.user.address || '',
            phonenumber: finalUserData.user.phonenumber || '',
            parentname: finalUserData.user.parentname || '',
            avatar: finalAvatarUrl
          });

          if (finalUserData.user.usertype === 'Teacher') {
            setTeacherData({
              degree: finalUserData.user.degree || '',
              institution: finalUserData.user.institution || '',
              education_duration: finalUserData.user.education_duration || '',
              education_start_date: finalUserData.user.education_start_date || '',
              education_end_date: finalUserData.user.education_end_date || '',
              education_file: finalUserData.user.education_file || null,
              designation: finalUserData.user.designation || '',
              company: finalUserData.user.company || '',
              experience_duration: finalUserData.user.experience_duration || '',
              experience_start_date: finalUserData.user.experience_start_date || '',
              experience_end_date: finalUserData.user.experience_end_date || '',
              experience_file: finalUserData.user.experience_file || null,
              availability_day: finalUserData.user.availability_day || '',
              availability_time: finalUserData.user.availability_time || '',
              selected_course: finalUserData.user.selected_course || '',
              meeting_link: finalUserData.user.meeting_link || '',
              bank_name: finalUserData.user.bank_name || '',
              iban: finalUserData.user.iban || '',
              mobile_wallet: finalUserData.user.mobile_wallet || '',
              payment_preference: finalUserData.user.payment_preference || ''
            });
          }
        } else {
          console.error("❌ Invalid user data structure:", finalUserData);
          console.error("❌ Expected: {Data: true, user: {...}}");
          console.error("❌ Received:", finalUserData);
          throw new Error("Invalid user data received from server");
        }
      } catch (err) {
        console.error("❌ Error in fetchUserData:", err);
        console.error("❌ Error details:", err.message);
        setError(err.message);
        toast.error(`Failed to load user data: ${err.message}`);
        console.log("🔧 DEBUG: If you see 'session is not valid', please:");
        console.log("1. Make sure you are logged in");
        console.log("2. Check if cookies are enabled");
        console.log("3. Try logging out and logging in again");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePasswordChange = (e) => {
    const { name, value } = e.target;
    setPasswordData((prev) => ({ ...prev, [name]: value }));
  };

  const handleTeacherDataChange = (e) => {
    const { name, value } = e.target;
    setTeacherData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageClick = () => fileInputRef.current.click();

  const handleImageError = (e) => {
    console.error("❌ Image failed to load:", e.target.src);
    e.target.src = "https://via.placeholder.com/150?text=No+Image";
  };

  const handleImageLoad = () => {
    // Image loaded successfully - no console log needed
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    try {
      let userId = userInfo?.User_id || localStorage.getItem("User_id");

      if (!userId) {
        toast.error("User not authenticated. Please login again.");
        return;
      }

      // Validate file size (e.g., max 5MB)
      if (file.size > 5 * 1024 * 1024) {
        toast.error("Image size must be less than 5MB");
        return;
      }

      // Validate file type
      if (!file.type.startsWith('image/')) {
        toast.error("Please upload an image file");
        return;
      }

      const imageForm = new FormData();
      imageForm.append("avatar", file);

      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editUser/${userId}`, {
        method: "PUT",
        body: imageForm,
        credentials: 'include'
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("Image updated successfully", {
          position: "top-center",
          autoClose: 2000,
        });

        // Use the filename returned by the server
        const savedFilename = result.updatedData.avatar || file.name;
        const newAvatarUrl = `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getUimage/${savedFilename}`;

        setFormData(prev => ({
          ...prev,
          avatar: newAvatarUrl
        }));

        // Update UserContext if available
        if (setUserInfo) {
          setUserInfo(prev => ({ ...prev, avatar: newAvatarUrl }));
        }

      } else {
        toast.error(result.message || "Failed to update image");
      }
    } catch (error) {
      console.error("❌ Error uploading image:", error);
      toast.error("Error uploading image");
    }
  };

  const handleSaveChanges = async () => {
    try {
      console.log("💾 Starting profile update...");

      let userId = userInfo?.User_id || localStorage.getItem("User_id");

      console.log("💾 Getting User_id for profile update:", userId);
      console.log("💾 UserContext User_id:", userInfo?.User_id);
      console.log("💾 localStorage User_id:", localStorage.getItem("User_id"));

      if (!userId) {
        toast.error("User not authenticated. Please login again.");
        return;
      }

      console.log("💾 Updating profile for User_id:", userId);
      console.log("💾 Form data to update:", formData);

      const form = new FormData();
      form.append("firstname", formData.firstname);
      form.append("lastname", formData.lastname);
      form.append("gender", formData.gender);
      if (formData.dateofbirth) form.append("dateofbirth", formData.dateofbirth);
      form.append("address", formData.address);
      form.append("phonenumber", formData.phonenumber);
      form.append("parentname", formData.parentname);

      console.log("💾 NOT sending avatar field to preserve existing image");

      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editUser/${userId}`, {
        method: "PUT",
        body: form,
        credentials: 'include'
      });

      const result = await response.json();
      console.log("💾 Profile update response:", result);

      if (response.ok) {
        toast.success("Profile updated successfully", {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        toast.error(result.message || "Update failed");
      }
    } catch (err) {
      console.error("❌ Error updating profile:", err);
      toast.error("An error occurred while updating profile");
    }
  };

  const handleChangePassword = async () => {
    const { oldPassword, newPassword, confirmPassword } = passwordData;

    if (!oldPassword || !newPassword || !confirmPassword) return toast.error("All fields required");
    if (newPassword !== confirmPassword) return toast.error("Passwords do not match");

    try {
      console.log("🔐 Starting password change...");

      let userId = userInfo?.User_id || localStorage.getItem("User_id");

      console.log("🔐 Getting User_id for password change:", userId);
      console.log("🔐 UserContext User_id:", userInfo?.User_id);
      console.log("🔐 localStorage User_id:", localStorage.getItem("User_id"));

      if (!userId) {
        toast.error("User not authenticated. Please login again.");
        return;
      }
      console.log("🔐 Changing password for User_id:", userId);

      const checkRes = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/checkOldPassword`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ oldPassword, User_id: userId }),
        credentials: 'include'
      });

      console.log("🔐 Password check response status:", checkRes.status);

      if (checkRes.status !== 200) {
        return toast.error("Old password incorrect");
      }

      const updateRes = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/updatePassword`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ userId, newPassword }),
        credentials: 'include'
      });

      const result = await updateRes.json();
      console.log("🔐 Password update response:", result);

      if (updateRes.ok) {
        toast.success("Password updated successfully", {
          position: "top-center",
          autoClose: 2000,
        });
        setPasswordData({ oldPassword: '', newPassword: '', confirmPassword: '' });
      } else {
        toast.error(result.message || "Password update failed");
      }
    } catch (error) {
      console.error("❌ Error updating password:", error);
      toast.error("An error occurred while updating password");
    }
  };

  // Updated Education Save Function (from Teacher.js)
  const handleSaveEducation = async () => {
    if (!teacherId) {
      toast.error('Teacher ID not found. Please try refreshing the page.');
      return;
    }

    const formData = new FormData();
    formData.append("degreeName", teacherData.degree);
    formData.append("instituteName", teacherData.institution);
    formData.append("DurationOfCourse", teacherData.education_duration);
    formData.append("yearStart", teacherData.education_start_date ? parseInt(teacherData.education_start_date.split('-')[0]) : '');
    formData.append("yearEnd", teacherData.education_end_date ? parseInt(teacherData.education_end_date.split('-')[0]) : '');
    formData.append("degreeFile", teacherData.education_file);

    if (!teacherData.degree || !teacherData.institution || !teacherData.education_duration || !teacherData.education_start_date || !teacherData.education_end_date) {
      toast.error('All fields are required.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveEducationDetails/${teacherId}`, formData)
        .then(response => {
          toast.success('Education data has been saved.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          // ✅ Refresh data
          fetchEducationData(teacherId);
        })
        .catch(error => {
          toast.error('Something went wrong.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          console.log('Error saving education details', error);
        });
    }
  };

  // Updated Experience Save Function (from Teacher.js)
  const handleSaveExperience = async () => {
    if (!teacherId) {
      toast.error('Teacher ID not found. Please try refreshing the page.');
      return;
    }

    const formData = new FormData();
    formData.append("designation", teacherData.designation);
    formData.append("company", teacherData.company);
    formData.append("DurationOfService", teacherData.experience_duration);
    formData.append("yearStart", teacherData.experience_start_date ? parseInt(teacherData.experience_start_date.split('-')[0]) : '');
    formData.append("yearEnd", teacherData.experience_end_date ? parseInt(teacherData.experience_end_date.split('-')[0]) : '');
    formData.append("expFile", teacherData.experience_file);

    if (!teacherData.designation || !teacherData.company || !teacherData.experience_duration || !teacherData.experience_start_date || !teacherData.experience_end_date) {
      toast.error('All fields are required.', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } else {
      axios.post(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveExperienceDetails/${teacherId}`, formData)
        .then(response => {
          toast.success('Experience data has been saved.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          // ✅ Refresh data
          fetchExperienceData(teacherId);
        })
        .catch(error => {
          toast.error('Something went wrong.', {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 2000,
          });
          console.log('Error saving experience details', error);
        });
    }
  };

  const handleSaveAvailability = async () => {
    if (!teacherId) {
      toast.error("Teacher ID not found. Please try refreshing the page.");
      return;
    }

    const selectedDay = teacherData.availability_day;
    const selectedTime = teacherData.availability_time;

    if (!selectedDay || !selectedTime) {
      toast.error("Please select both day and time for availability.");
      return;
    }

    const availabilityData = {
      [selectedDay]: {
        day: selectedDay,
        time: selectedTime
      }
    };

    console.log('💾 Saving availability:', availabilityData);
    console.log('💾 Teacher_id:', teacherId);

    try {
      const response = await fetch(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editTeacherAvailability/${teacherId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(availabilityData),
        }
      );

      if (response.ok) {
        toast.success("Availability saved successfully", {
          position: "top-center",
          autoClose: 2000,
        });

        setTeacherData(prev => ({
          ...prev,
          availability_day: '',
          availability_time: ''
        }));

        console.log('✅ Availability saved successfully');
      } else {
        const errorData = await response.json();
        console.log('❌ Failed to save availability:', errorData);
        toast.error("Failed to save availability. Please try again.");
      }
    } catch (error) {
      console.error('❌ Error saving availability:', error);
      toast.error("Error saving availability. Please check your connection.");
    }
  };

  const handleSaveCourse = () => {
    toast.success("Course saved successfully", {
      position: "top-center",
      autoClose: 2000,
    });
  };

  const handleSaveMeetingLink = async () => {
    if (!teacherId) {
      toast.error("Teacher ID not found. Please try refreshing the page.");
      return;
    }

    const meetingLink = teacherData.meeting_link;

    if (!meetingLink || !meetingLink.trim()) {
      toast.error("Please enter a meeting link.");
      return;
    }

    const currentUserId = localStorage.getItem("User_id");
    if (!currentUserId) {
      toast.error("User ID not found. Please refresh the page and try again.");
      return;
    }

    console.log('💾 Saving meeting link:', meetingLink);
    console.log('💾 Teacher_id:', teacherId);
    console.log('💾 User_id:', currentUserId);

    try {
      const response = await fetch(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/saveMeetLink/${teacherId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({
            meetLink: meetingLink.trim()
          }),
        }
      );

      console.log('📋 Meeting link response status:', response.status);
      console.log('📋 Meeting link response ok:', response.ok);

      if (response.ok) {
        const successData = await response.json();
        console.log('✅ Meeting link saved successfully:', successData);
        toast.success("Meeting link saved successfully", {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        console.log('❌ Meeting link response not ok, status:', response.status);
        try {
          const errorData = await response.json();
          console.log('❌ Meeting link error response:', errorData);
          toast.error(`Failed to save meeting link: ${errorData.message || 'Unknown error'}`);
        } catch (parseError) {
          console.log('❌ Could not parse meeting link error response:', parseError);
          const errorText = await response.text();
          console.log('❌ Raw meeting link error response:', errorText);
          toast.error("Failed to save meeting link. Please try again.");
        }
      }
    } catch (error) {
      console.error('❌ Error saving meeting link:', error);
      toast.error("Error saving meeting link. Please check your connection.");
    }
  };

  // ✅ New Fetch Functions
  const fetchEducationData = async (tId) => {
    try {
      const res = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getEducationDetails/${tId}`);
      if (res.data.educationDetails && res.data.educationDetails.length > 0) {
        const edu = res.data.educationDetails[0]; // Take latest/first
        setTeacherData(prev => ({
          ...prev,
          degree: edu.degreeName || '',
          institution: edu.instituteName || '',
          education_duration: edu.DurationOfCourse || '',
          education_start_date: edu.yearStart ? `${edu.yearStart}-01-01` : '', // Best effort for date input
        }));
      }
    } catch (err) {
      console.error("Error fetching education:", err);
    }
  };

  const fetchExperienceData = async (tId) => {
    try {
      const res = await axios.get(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/getExperienceDetails/${tId}`);
      if (res.data.experienceDetails && res.data.experienceDetails.length > 0) {
        const exp = res.data.experienceDetails[0];
        setTeacherData(prev => ({
          ...prev,
          designation: exp.Designation || '',
          company: exp.CompanyName || '',
          experience_duration: exp.DurationOfService || '',
          experience_start_date: exp.YearStart ? `${exp.YearStart}-01-01` : '',
        }));
      }
    } catch (err) {
      console.error("Error fetching experience:", err);
    }
  };

  const handleSaveBankDetails = async () => {
    if (!teacherId) {
      toast.error("Teacher ID not found. Please try refreshing the page.");
      return;
    }

    const bankData = {
      BankName: teacherData.bank_name,
      BankAccountIBAN: teacherData.iban,
      MobileWalletNo: teacherData.mobile_wallet,
      Preference: teacherData.payment_preference,
      MobileWallletName: 'Mobile Wallet'
    };

    if (!bankData.Preference) {
      toast.error("Please select a payment preference.");
      return;
    }

    if (bankData.Preference === 'Bank Transfer' && (!bankData.BankName || !bankData.BankAccountIBAN)) {
      toast.error("Please fill in bank name and IBAN for bank transfer.");
      return;
    }

    if (bankData.Preference === 'Mobile Wallet' && !bankData.MobileWalletNo) {
      toast.error("Please fill in mobile wallet number.");
      return;
    }

    console.log('💾 Saving bank details:', bankData);
    console.log('💾 Teacher_id:', teacherId);
    console.log('💾 API URL:', `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editBankDetails/${teacherId}`);
    console.log('💾 Request body:', JSON.stringify(bankData));

    try {
      const response = await fetch(
        `${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/editBankDetails/${teacherId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify(bankData),
        }
      );

      console.log('📋 Response status:', response.status);
      console.log('📋 Response ok:', response.ok);

      if (response.ok) {
        const successData = await response.json();
        console.log('✅ Bank details saved successfully:', successData);
        toast.success("Bank details saved successfully", {
          position: "top-center",
          autoClose: 2000,
        });
      } else {
        console.log('❌ Response not ok, status:', response.status);
        try {
          const errorData = await response.json();
          console.log('❌ Error response data:', errorData);
          toast.error(`Failed to save bank details: ${errorData.message || 'Unknown error'}`);
        } catch (parseError) {
          console.log('❌ Could not parse error response:', parseError);
          const errorText = await response.text();
          console.log('❌ Raw error response:', errorText);
          toast.error("Failed to save bank details. Please try again.");
        }
      }
    } catch (error) {
      console.error('❌ Error saving bank details:', error);
      toast.error("Error saving bank details. Please check your connection.");
    }
  };

  if (loading) {
    return (
      <div className="loading-container">
        <div>Loading user data...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <h2>❌ Authentication Error</h2>
        <p><strong>Issue:</strong> {error}</p>

        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#fff3cd', border: '1px solid #ffeaa7', borderRadius: '5px' }}>
          <h3>🔍 Quick Diagnosis:</h3>
          <p><strong>This error means you are not properly logged in.</strong></p>

          <h4>Please check:</h4>
          <ol>
            <li><strong>Are you logged in?</strong> - Look at the top navigation bar. Do you see your name/avatar?</li>
            <li><strong>Did login succeed?</strong> - After entering username/password, were you redirected to dashboard?</li>
            <li><strong>Session expired?</strong> - Try logging out and logging in again</li>
          </ol>
        </div>

        <div style={{ marginTop: '20px' }}>
          <h3>🔧 Solutions:</h3>
          <ul>
            <li><strong>Step 1:</strong> Go to home page and login again</li>
            <li><strong>Step 2:</strong> Make sure you see your name in the navigation bar after login</li>
            <li><strong>Step 3:</strong> Then try accessing Edit Profile again</li>
          </ul>
        </div>

        <div style={{ marginTop: '20px', padding: '15px', backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', borderRadius: '5px' }}>
          <h4>🔧 User ID Required:</h4>
          <p><strong>The session system is not working properly.</strong></p>
          <p>Please enter your User ID to access your profile:</p>
          <div style={{ marginBottom: '10px' }}>
            <input
              type="text"
              placeholder="Enter your User ID (e.g., 1, 2, 3, etc.)"
              value={manualUserId}
              onChange={(e) => setManualUserId(e.target.value)}
              style={{ padding: '8px', marginRight: '10px', border: '1px solid #ccc', borderRadius: '3px', width: '200px' }}
            />
            <button onClick={retryWithManualUserId} style={{ padding: '8px 15px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '3px' }}>
              Load My Profile
            </button>
          </div>
          <div style={{ marginTop: '10px', padding: '10px', backgroundColor: '#e7f3ff', border: '1px solid #b3d9ff', borderRadius: '3px' }}>
            <strong>💡 How to find your User ID:</strong>
            <ul style={{ margin: '5px 0', paddingLeft: '20px' }}>
              <li>Check with your administrator</li>
              <li>Look at your registration confirmation</li>
              <li>Try common IDs: 1, 2, 3, etc.</li>
            </ul>
          </div>
        </div>

        <div style={{ marginTop: '20px' }}>
          <button onClick={() => window.location.href = '/'} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#007bff', color: 'white', border: 'none', borderRadius: '5px' }}>
            🏠 Go to Home & Login
          </button>
          <button onClick={clearAllUserData} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#dc3545', color: 'white', border: 'none', borderRadius: '5px' }}>
            🧹 Clear All Data & Fresh Login
          </button>
          <button onClick={debugAllUserData} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#6f42c1', color: 'white', border: 'none', borderRadius: '5px' }}>
            🔍 Debug User Data
          </button>
          <button onClick={testImageUrl} style={{ marginTop: '10px', padding: '10px 20px', marginRight: '10px', backgroundColor: '#17a2b8', color: 'white', border: 'none', borderRadius: '5px' }}>
            🧪 Test Image URL
          </button>
          <button onClick={() => window.location.reload()} style={{ marginTop: '10px', padding: '10px 20px', backgroundColor: '#28a745', color: 'white', border: 'none', borderRadius: '5px' }}>
            🔄 Refresh Page
          </button>
        </div>
      </div>
    );
  }

  if (userType === 'Teacher') {
    return (
      <div className="profile-layout">
        <TeacherNav onLogout={onLogout} />
        <div className="profile-container">
          <div className="header-section">
            <h1 className="profile-title">Profile</h1>
            <div className="user-notification">
              <Bell className="notification-icon" size={20} />
              <span className="user-name">{formData.firstname} {formData.lastname}</span>
              <div className="user-avatar">
                <User size={16} />
              </div>
            </div>
          </div>

          {/* Personal Info Section */}
          <div className="personal-info-section">
            <h2 className="section-title">Personal Info</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">First Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="firstname"
                    value={formData.firstname}
                    onChange={handleInputChange}
                    placeholder="Enter first name"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Last Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="lastname"
                    value={formData.lastname}
                    onChange={handleInputChange}
                    placeholder="Enter last name"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Gender</label>
                  <select
                    className="form-input"
                    name="gender"
                    value={formData.gender}
                    onChange={handleInputChange}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Birthday</label>
                  <input
                    type="date"
                    className="form-input"
                    name="dateofbirth"
                    value={formData.dateofbirth}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Address</label>
                  <input
                    type="text"
                    className="form-input"
                    name="address"
                    value={formData.address}
                    onChange={handleInputChange}
                    placeholder="Enter address"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Phone No</label>
                  <input
                    type="tel"
                    className="form-input"
                    name="phonenumber"
                    value={formData.phonenumber}
                    onChange={handleInputChange}
                    placeholder="Enter phone number"
                  />
                </div>
              </div>
              <div className="button-container">
                <button type="button" className="save-button" onClick={handleSaveChanges}>Save Changes</button>
              </div>
            </form>
          </div>

          {/* Meeting Link Section */}
          <div className="section">
            <h2 className="section-title">Meeting Link</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Meeting Link</label>
                  <input
                    type="url"
                    className="form-input"
                    name="meeting_link"
                    value={teacherData.meeting_link}
                    onChange={handleTeacherDataChange}
                    placeholder="Enter meeting link"
                  />
                </div>
                <div className="input-group"></div>
                <div className="input-group">
                  <label className="input-label"> </label>
                  <button type="button" className="form-input save-button" onClick={handleSaveMeetingLink}>Save Changes</button>
                </div>
              </div>
            </form>
          </div>

          {/* Education Section */}
          <div className="section">
            <h2 className="section-title">Education</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Degree Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="degree"
                    value={teacherData.degree}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.degree ? "Enter degree" : "Not added"}
                  />
                  {!teacherData.degree && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Degree not added</span>}
                </div>
                <div className="input-group">
                  <label className="input-label">Institution Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="institution"
                    value={teacherData.institution}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.institution ? "Enter institution" : "Not added"}
                  />
                  {!teacherData.institution && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Institution not added</span>}
                </div>
                <div className="input-group">
                  <label className="input-label">Duration</label>
                  <input
                    type="text"
                    className="form-input"
                    name="education_duration"
                    value={teacherData.education_duration}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.education_duration ? "Enter duration" : "Not added"}
                  />
                  {!teacherData.education_duration && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Duration not added</span>}
                </div>
              </div>
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Start Date</label>
                  <input
                    type="date"
                    className="form-input"
                    name="education_start_date"
                    value={teacherData.education_start_date}
                    onChange={handleTeacherDataChange}
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">End Date</label>
                  <input
                    type="date"
                    className="form-input"
                    name="education_end_date"
                    value={teacherData.education_end_date}
                    onChange={handleTeacherDataChange}
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Upload File</label>
                  <input
                    type="file"
                    className="form-input"
                    ref={educationFileRef}
                    onChange={(e) => setTeacherData(prev => ({ ...prev, education_file: e.target.files[0] }))}
                    accept=".pdf,.doc,.docx"
                  />
                </div>
              </div>
              <div className="button-container">
                <button type="button" className="save-button" onClick={handleSaveEducation}>Save Changes</button>
              </div>
            </form>
          </div>

          {/* Experience Section */}
          <div className="section">
            <h2 className="section-title">Experience</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Designation</label>
                  <input
                    type="text"
                    className="form-input"
                    name="designation"
                    value={teacherData.designation}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.designation ? "Enter designation" : "Not added"}
                  />
                  {!teacherData.designation && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Designation not added</span>}
                </div>
                <div className="input-group">
                  <label className="input-label">Company Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="company"
                    value={teacherData.company}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.company ? "Enter company" : "Not added"}
                  />
                  {!teacherData.company && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Company not added</span>}
                </div>
                <div className="input-group">
                  <label className="input-label">Duration Of Service</label>
                  <input
                    type="text"
                    className="form-input"
                    name="experience_duration"
                    value={teacherData.experience_duration}
                    onChange={handleTeacherDataChange}
                    placeholder={teacherData.experience_duration ? "Enter duration" : "Not added"}
                  />
                  {!teacherData.experience_duration && <span style={{ fontSize: '10px', color: '#ff4d4d' }}>Duration not added</span>}
                </div>
              </div>
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Start Date</label>
                  <input
                    type="date"
                    className="form-input"
                    name="experience_start_date"
                    value={teacherData.experience_start_date}
                    onChange={handleTeacherDataChange}
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">End Date</label>
                  <input
                    type="date"
                    className="form-input"
                    name="experience_end_date"
                    value={teacherData.experience_end_date}
                    onChange={handleTeacherDataChange}
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Upload File</label>
                  <input
                    type="file"
                    className="form-input"
                    ref={experienceFileRef}
                    onChange={(e) => setTeacherData(prev => ({ ...prev, experience_file: e.target.files[0] }))}
                    accept=".pdf,.doc,.docx"
                  />
                </div>
              </div>
              <div className="button-container">
                <button type="button" className="save-button" onClick={handleSaveExperience}>Save Changes</button>
              </div>
            </form>
          </div>

          {/* Weekly Availability Section */}
          <div className="section">
            <h2 className="section-title">Weekly Availability</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Select Day</label>
                  <select
                    className="form-input"
                    name="availability_day"
                    value={teacherData.availability_day}
                    onChange={handleTeacherDataChange}
                  >
                    <option value="">Select Day</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                    <option value="Sunday">Sunday</option>
                  </select>
                </div>
                <div className="input-group">
                  <label className="input-label">Select Time</label>
                  <select
                    className="form-input"
                    name="availability_time"
                    value={teacherData.availability_time}
                    onChange={handleTeacherDataChange}
                  >
                    <option value="">Select Time</option>
                    <option value="9:00 AM - 5:00 PM">9:00 AM - 5:00 PM</option>
                    <option value="10:00 AM - 6:00 PM">10:00 AM - 6:00 PM</option>
                    <option value="11:00 AM - 7:00 PM">11:00 AM - 7:00 PM</option>
                  </select>
                </div>
                <div className="input-group">
                  <label className="input-label"> </label>
                  <button type="button" className="form-input save-button" onClick={handleSaveAvailability}>Add Availability</button>
                </div>
              </div>
            </form>
          </div>

          {/* Courses Section */}
          <div className="section">
            <h2 className="section-title">Courses</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Select Course</label>
                  <select
                    className="form-input"
                    name="selected_course"
                    value={teacherData.selected_course}
                    onChange={handleTeacherDataChange}
                  >
                    <option value="">Select a course</option>
                    <option value="Web Development">Web Development</option>
                    <option value="Mobile Development">Mobile Development</option>
                    <option value="Data Science">Data Science</option>
                  </select>
                </div>
                <div className="input-group"></div>
                <div className="input-group">
                  <label className="input-label"> </label>
                  <button type="button" className="form-input save-button" onClick={handleSaveCourse}>Save Changes</button>
                </div>
              </div>
            </form>
          </div>



          {/* Bank Details Section */}
          <div className="section">
            <h2 className="section-title">Bank Details</h2>
            <form className="info-form">
              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Bank Name</label>
                  <input
                    type="text"
                    className="form-input"
                    name="bank_name"
                    value={teacherData.bank_name}
                    onChange={handleTeacherDataChange}
                    placeholder="Enter bank name"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">IBAN</label>
                  <input
                    type="text"
                    className="form-input"
                    name="iban"
                    value={teacherData.iban}
                    onChange={handleTeacherDataChange}
                    placeholder="Enter IBAN"
                  />
                </div>
                <div className="input-group">
                  <label className="input-label">Mobile Wallet</label>
                  <input
                    type="text"
                    className="form-input"
                    name="mobile_wallet"
                    value={teacherData.mobile_wallet}
                    onChange={handleTeacherDataChange}
                    placeholder="Enter mobile number"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="input-group">
                  <label className="input-label">Payment Preference</label>
                  <select
                    className="form-input"
                    name="payment_preference"
                    value={teacherData.payment_preference}
                    onChange={handleTeacherDataChange}
                  >
                    <option value="">Select Payment Method</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                    <option value="Mobile Wallet">Mobile Wallet</option>
                  </select>
                </div>
                <div className="input-group"></div>
                <div className="input-group"></div>
              </div>

              <div className="button-container">
                <button type="button" className="save-button" onClick={handleSaveBankDetails}>Save Changes</button>
              </div>
            </form>
          </div>

          <ToastContainer />
        </div>
      </div>
    );
  }

  return (
    <>
      {isAdmin ? <AdminNav onLogout={onLogout} /> : <StudentNav onLogout={onLogout} />}
      <div className="profile-container">
        <div className="profile-header">
          <h1>Profile</h1>
          <div className="profile-header-right">
            <div className="notification-container">
              <Bell className="notification-icon" size={28} />
              <div className="notification-badge"></div>
            </div>
            <div className="user-info">
              <div className="user-avatar">
                <img
                  src={`${formData.avatar || "https://via.placeholder.com/150?text=No+Avatar"}?t=${new Date().getTime()}`}
                  alt="User Avatar"
                  onError={handleImageError}
                  onLoad={handleImageLoad}
                />
              </div>
              <span className="user-name">{formData.firstname || 'User'} {formData.lastname}</span>
            </div>
          </div>
        </div>

        <div className="profile-content">
          <div className="profile-image-section">
            <div className="profile-image-container">
              <div className="profile-image">
                <img
                  src={`${formData.avatar || "https://via.placeholder.com/150?text=No+Image"}?t=${new Date().getTime()}`}
                  alt="Profile"
                  onError={handleImageError}
                  onLoad={handleImageLoad}
                />
              </div>
              <div className="edit-profile-overlay" onClick={handleImageClick}>
                <Camera size={16} />
                <span>Edit Profile Image</span>
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>

          <div className="profile-form">
            <div className="form-row">
              <div className="form-group">
                <label>First Name:</label>
                <input type="text" name="firstname" value={formData.firstname} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Last Name:</label>
                <input type="text" name="lastname" value={formData.lastname} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Gender:</label>
                <input type="text" name="gender" value={formData.gender} onChange={handleInputChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label>Birthday:</label>
                <input type="date" name="dateofbirth" value={formData.dateofbirth} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Address:</label>
                <input type="text" name="address" value={formData.address} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Phone No:</label>
                <input type="text" name="phonenumber" value={formData.phonenumber} onChange={handleInputChange} />
              </div>
            </div>
            <div className="form-row">
              <div className="form-group parent-name">
                <label>Parent Name:</label>
                <input type="text" name="parentname" value={formData.parentname} onChange={handleInputChange} />
              </div>
            </div>
            <div className="save-changes-section">
              <button className="save-changes-btn" onClick={handleSaveChanges}>Save Changes</button>
            </div>
          </div>

          <div className="change-password-section">
            <h2>Change Password</h2>
            <div className="password-form">
              <div className="password-row">
                <div className="form-group" style={{ position: 'relative' }}>
                  <label>Old Password:</label>
                  <input
                    type={showOldPassword ? "text" : "password"}
                    name="oldPassword"
                    value={passwordData.oldPassword}
                    onChange={handlePasswordChange}
                    style={{ paddingRight: '40px' }}
                  />
                  <button
                    type="button"
                    onClick={toggleOldPasswordVisibility}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '60%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '16px'
                    }}
                  >
                    {showOldPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <div className="form-group" style={{ position: 'relative' }}>
                  <label>New Password:</label>
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="newPassword"
                    value={passwordData.newPassword}
                    onChange={handlePasswordChange}
                    style={{ paddingRight: '40px' }}
                  />
                  <button
                    type="button"
                    onClick={toggleNewPasswordVisibility}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '60%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '16px'
                    }}
                  >
                    {showNewPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
                <div className="form-group" style={{ position: 'relative' }}>
                  <label>Confirm Password:</label>
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirmPassword"
                    value={passwordData.confirmPassword}
                    onChange={handlePasswordChange}
                    style={{ paddingRight: '40px' }}
                  />
                  <button
                    type="button"
                    onClick={toggleConfirmPasswordVisibility}
                    style={{
                      position: 'absolute',
                      right: '10px',
                      top: '60%',
                      transform: 'translateY(-50%)',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#666',
                      fontSize: '16px'
                    }}
                  >
                    {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
                  </button>
                </div>
              </div>
              <div className="password-actions">
                <button className="change-password-btn" onClick={handleChangePassword}>Change Password</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};

export default EditProfile;